<template>
    <div class="portlet light">
        <div class="ss-titre">
            <span class="font-red-sunglo uppercase bold">L'ENCADRANT</span>
        </div>
        <div class="portlet-body">
            <div class="form-group">
    <div>
       <!-- ------------------------------------radio button----------------------------------------->
        <div class="form-group">
            <div>
                <input type="radio" id="salarie"  value="salarie" v-model="encadrant" @change="updateEncadrant()">
                <label for="salarie">Associé</label>
                </div>
                <input type="radio" id="renfort" value="renfort" v-model="encadrant" @change="updateEncadrant()">
                <label for="renfort">Renfort</label>
        </div>
        <!-- -------------------------------------End radio button----------------------------------------->

        <!-- -------------------------------------Select encadrant ----------------------------------------->

       <!-----------------------------salarie----------------------------------->
        <div class="row" v-if="encadrant == 'salarie'">
            <div class="col-md-3" >
                <label>Choisissez le Professionnel (associé)</label>

                <select name="user_reinforcements" v-model="user" @change="addUser()" class="form-control">
                    <option v-for="user in users" :value="user">{{+user.pivot.priority+1}}★ - {{user.fullName}}</option>
                </select>
            </div>

        </div>
       <!--- -------------------------------------- end salarie--------------------------------------------------->

        <!--------------------------------------------- renfort--------------------------------------------------->
        <div class="row" v-if="encadrant == 'renfort'">
            <div class="col-md-3 " v-if="encadrant == 'renfort'">
                <label>Choisissez le professionnel (renfort)*</label>
                <select name="renfort_reinforcements" v-model="renfort" class="form-control">
                    <option v-for="renfort in renforts" :value="renfort">{{+renfort.priority+1}}★ - {{renfort.fullName}}</option>
                </select>
            </div>
            <div class="col-md-4 valign">
                <label>Honoraires du pro pour l'activité (en €)*</label>
                <input type="number" name="part" ref="input" class="form-control" v-model="renfortpart" />
            </div>
            <div class="col-md-1 text-center valign">
                 <a class="btn btn-success billingSuccess" @click.prevent="addRenfort()">Valider</a>
            </div>
        </div>
       <!---------------------------------------------end renfort------------------------------------------------>
       <!-------------------------------------------- end select encadrant--------------------------------------->

        <div id="errors_valid" v-show="errors != false" style="color:red">Veuillez sélectionner un professionnel et ses honoraires ou vérifier que vous avez ajouté une activité dans la rubrique activité plus haut.
        </div>
        <div v-show="renfortparterrors != false && this.renfortpart == '' " style="color:red">Veuillez renseigner l'honoraire du renfort</div>

            <!-- ----------------------table------------------>
        <table class="table table-striped" v-if="this.value.length >0 || this.renfortsValue.length >0">
            <thead>
            <tr>
                <th>Nom du pro</th>
               <!-- <th>Honoraires de l'activité</th>-->
                <th></th>
            </tr>
            </thead>
            <tbody>
           <!-- -----------------------salarie--------------------------------->
            <tr v-if="encadrant == 'salarie'" v-for="user in value">
                <td>{{ user.name }}</td>
              <!--  <td>{{ user.part }} €</td>-->
                <input type="hidden" :value="user.id" name="guidessup[]" id="guidesSup"/>
                <input type="hidden" :value="part" name="parts[]"/>
            </tr>
           <!-- -----------------------renfort--------------------------------->
            <tr v-if="encadrant == 'renfort'" v-for="renfort in renfortsValue">
                <td>{{ renfort.name }}</td>
                <td>{{ renfort.part }} €</td>
                <input type="hidden" :value="renfort.id" name="renfortssup[]" id="renfortsSup"/>
                <input type="hidden" :value="renfort.part" name="parts[]" />
                <td>
                    <a href="javascript:;" class="btn btn-danger pull-right" @click="deleteRenfort(renfort)"><i class="fa fa-trash"></i></a>
                    <a href="javascript:;" class="btn btn-primary pull-right" @click="updateRenfort(renfort)"><i class="fas fa-pencil-alt"></i></a>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {

        name: 'selectBillingEncadrant',
        props: ['officeUsers','usersReinforcement', 'officeRenforts', 'renfortsReinforcement','isencadrantsalarie','hasbilling'],
        data () {
            return {
                'users': Object.assign([], _.sortBy(this.officeUsers,function (i) { return 4-i.pivot.priority+"_"+i.fullName.toLowerCase(); })),
                'renforts': Object.assign([], _.sortBy(this.officeRenforts,function (i) { return 4-i.priority+"_"+i.fullName.toLowerCase(); })),
                'value': Object.assign([], this.usersReinforcement),
                'renfortsValue': Object.assign([], this.renfortsReinforcement),
                'user': '',
                'renfort': '',
                'part': '',
                'renfortpart' : '',
                'renfortparterrors' : false,
                'errors' : false,
                'encadrant': 'salarie',
            }
        },
        computed: {
            price() {
                let price = 0
                for (var i = this.value.length - 1; i >= 0; i--) {
                    (price += this.value[i].part)
                }
                this.$parent.$emit('update:totalDispatchedPrice', {
                    'type' : 'user',
                    'quantity' : price
                })
                return price
            },
        },
        methods: {
            addUser() {
                if (this.user != '') {
                    if(this.value.length>0){
                        this.value.splice(this.value.indexOf(this.user), 1)
                    }
                    this.user['part'] = this.part
                    this.value.push(this.user)
                    this.errors = false
                }else{
                    this.errors = true
                }
            },
            addRenfort() {
                if (this.renfort != '' ) {
                    if (this.renfortpart != ''){

                        this.renfort['part'] = this.renfortpart
                        this.renfortsValue.push(this.renfort)
                        this.renforts.splice(this.renforts.indexOf(this.renfort), 1)
                        this.renfortpart = ''
                        this.renfort = ''
                        this.errors = false,
                        this.renfortparterrors = false
                    } else {
                        this.renfortparterrors = true
                    }
                }else{
                    this.errors = true
                }
            },
            deleteUser(user) {
                this.users.push(user)
                this.value.splice(this.value.indexOf(user), 1)
            },
            deleteRenfort(user) {
                this.renforts.push(user)
                this.renfortsValue.splice(this.renfortsValue.indexOf(renfort), 1)
            },
            updateRenfort(renfort) {
                this.renforts.push(renfort)
                this.renfort = renfort
                this.renfortpart = renfort.renfortpart
                this.renfortsValue.splice(this.renfortsValue.indexOf(renfort), 1)
                this.$refs.input.focus()
            },
            updateEncadrant(){
                this.$parent.$emit('update:encadrant', {
                    'encadrant': this.encadrant
                })
            }
        },
        mounted () {
            this.$parent.$on('update:totalDispatchedPrice', (e) => {

                this.part = e.quantity
                if (this.value.length >0){
                    for (var i = this.value.length - 1; i >= 0; i--) {
                        this.value[i].part = e.quantity
                    }
                }
            })
            this.$parent.$emit('update:encadrant', {
                'encadrant': this.encadrant
            })

            if(this.isencadrantsalarie == 0){
                this.encadrant = 'renfort'
            }

        },
       /** updated(){
            if(this.encadrant == 'renfort'){
                    this.re = ''
            }
        }**/
    }
</script>

<style lang="css" scoped>
    .valign{
        display: flex;
        justify-content: center;
        align-items: center;
        height: 8.4rem;
    }
</style>
